import _ from '../vendors/_';
import {Point} from '../../@types/shared';

export default function (e, options?: { pagePosition?: boolean, screenPosition?: boolean }): Point {
  options = _.assignIn({
    pagePosition: false,
    screenPosition: false,
  }, options);
  if (e.touches && e.touches[0]) {
    if (options.pagePosition) {
      return {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY,
      };
    } else if (options.screenPosition) {
      return {
        x: e.touches[0].screenX,
        y: e.touches[0].screenY,
      };
    }
    return {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
    };
  }
  return {
    x: e.clientX,
    y: e.clientY,
  };
}
